import type { ComponentProps } from "react";
import ShippingAgencyTransferDecisionDrawer from "../ShippingAgencyTransferDecisionDrawer";

type Props = Omit<ComponentProps<typeof ShippingAgencyTransferDecisionDrawer>, "decision">;

const ApproveShippingAgencyTransferDrawer = (props: Props) => (
  <ShippingAgencyTransferDecisionDrawer {...props} decision="approve" />
);

export default ApproveShippingAgencyTransferDrawer;
